import { InjectionToken } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';


export let JWT_HELPER_TOKEN = new InjectionToken<JwtHelperService>('jwtHelperService');
